module.exports = __webpack_public_path__ + "static/media/demid.61909364.jpg";